var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center h-screen"},[_c('div',{staticClass:"w-4/5 flex flex-col items-center"},[_c('p',{staticClass:"text-2xl"},[_vm._v("Carregando...")]),_c('vs-progress',{attrs:{"indeterminate":"","color":"primary"}},[_vm._v("primary")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }